import { Link } from "react-router-dom";
import { PenLine } from "lucide-react";

// Subtle, accessible author attribution for substantive educational pages.
export const AuthorByline = ({ className = "" }) => (
  <p className={`flex items-center gap-2 text-sm text-slate ${className}`} data-testid="author-byline">
    <PenLine size={15} className="text-gold" aria-hidden="true" />
    <span>
      Written by{" "}
      <Link
        to="/about"
        data-testid="author-byline-link"
        className="font-medium text-bronze underline-offset-4 transition-colors hover:text-gold hover:underline focus-ring rounded-sm"
      >
        Shawn King
      </Link>
    </span>
  </p>
);
